var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card col-2 flex justify-center"},[_c('q-img',{attrs:{"src":_vm.src,"width":"150px","height":"110px","contain":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }